import type { ReactElement } from 'react';
import cx from 'clsx';
import type { ButtonProps } from 'react-aria-components';
import { Button } from 'react-aria-components';
import styles from './trigger.module.css';

interface TriggerProps extends ButtonProps {
  isReadOnly?: boolean;
}

export function Trigger({ className, isReadOnly, ...props }: TriggerProps): ReactElement {
  return (
    <Button
      className={cx(styles.trigger, className, isReadOnly && styles['trigger--readonly'])}
      data-readonly={isReadOnly}
      {...props}
    />
  );
}
